import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetAllScorecardsQuery } from '../../../store/ai/scorecard'
import { Button } from '../../../components/Button/Button'
import { ReactComponent as ZocksLogo } from '../../../assets/ZocksLogo.svg'
import { Form, InputGroup } from 'react-bootstrap'
import { Scorecard } from '../../../models/Scorecard'

interface FormSelectorProps {
  handleFormSelected: (aiFeatureId: string, scorecardId: string) => void
}

export const FormSelector: React.FC<FormSelectorProps> = ({ handleFormSelected }) => {
  const accountId = useAppSelector(selectAccountId)
  const [forms, setForms] = useState<Scorecard[]>([])
  const [filteredForms, setFilteredForms] = useState<Scorecard[]>([])

  const { data: scorecardData } = useGetAllScorecardsQuery({
    accountId: accountId,
    type: 'form',
  })

  useEffect(() => {
    if (!scorecardData) {
      return
    }
    setForms(scorecardData.data)
    setFilteredForms(scorecardData.data)
  }, [scorecardData])

  const handleScorecardFilterChange = async (filter: string) => {
    setFilteredForms(forms.filter((form) => form.name.toLowerCase().includes(filter.toLowerCase())))
  }

  return (
    <div className='mb-4 d-flex flex-column gap-3'>
      <div className='d-flex py-3 px-2 align-items-center gap-3 ai-agent-chat-header'>
        <div className='d-flex align-items-center justify-content-center bg-black ai-agent-chat-header-logo zocks-border-0.25'>
          <ZocksLogo width={18} height={18} />
        </div>
        <div className='d-flex flex-column'>
          <span className='paragraph-small'>ZOCKS</span>
          <span className='paragraph-small'>AI Assistant</span>
        </div>
      </div>
      <div className='d-flex flex-column justify-content-between gap-3 flex-grow-1 '>
        <div className='d-flex zocks-gap-0.75 ps-2 pe-1'>
          <div className='d-flex align-items-center justify-content-center bg-black ai-agent-chat-message-logo zocks-border-0.25'>
            <ZocksLogo width={12} height={12} />
          </div>
          <div className='ai-agent-chat-message paragraph-medium'>Please select which form you would like to fill in.</div>
        </div>
        {filteredForms ? (
          <div className='d-flex flex-column gap-2'>
            <span className='lead-small text-uppercase'>List of forms</span>
            <div className='py-1'>
              <InputGroup className='input-group-container gap-4'>
                <Form.Control type='text' list='forms' onChange={(e) => handleScorecardFilterChange(e.currentTarget.value)} placeholder='Search in forms' />
                <i className='px-2 bi bi-search'></i>
              </InputGroup>
            </div>
            <div className='d-flex flex-wrap gap-2 align-items-start'>
              {filteredForms.map(({ id, name, aiFeatureIds }) => (
                <Button
                  key={id}
                  className='zocks-py-0.125 px-2 ai-agent-example paragraph-medium mw-0 rounded-5'
                  onClick={() => handleFormSelected(aiFeatureIds[0], id)}
                >
                  {name}
                </Button>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
